import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { FaCalendarAlt, FaArrowDown, FaPercentage, FaShieldAlt, FaUserShield, FaServer } from "react-icons/fa";
import TrustedCompanies from "../components/TrustedCompanies.js";
import TestimonialSection from "../components/imgration/TestimonialSection.js";
import CloudProviders from "../components/imgration/CloudProviders.js";
import MigrationGuides from "../components/imgration/MigrationGuides.js";
import WhyCloudMigration from "../components/imgration/WhyCloudMigration.js";
import OtherPlatforms from "../components/imgration/OtherPlatforms.js";
import CustomerPortalSection from "../components/imgration/CustomerPortalSection.js";
import ContactSection from "../components/imgration/ContactSection.js";
import Reaquestconsultation from "../components/imgration/RequestConsultation.js";
import { useNavigate } from "react-router-dom";
import SystemStatusSection from "../components/imgration/SystemStatusSection.js";
import InfrastructureSection from "../components/imgration/InfrastructureSection.js";
import TransparencySection from "../components/imgration/TransparencySection.js";
import MaintenanceHistorySection from "../components/imgration/MaintenanceHistorySection.js";
import FlexibilitySection from "../components/imgration/FlexibilitySection.js";
import DirectLineSection from "../components/imgration/DirectLineSection.js";
import DocumentsSection from "../components/imgration/DocumentsSection.js";
import EngineersAtFingertipsSection from "../components/imgration/EngineersAtFingertipsSection.js";

const Portal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate()

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  const requstconsultation = ()=>{
const element = document.getElementById("contact");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  }

  const [isZoomed, setIsZoomed] = useState(false);

  const handleImageClick = () => {
    setIsZoomed(true);
    // You can implement a modal/lightbox here
    console.log('Open image modal');
  };
  return (
    <>
      <Helmet>
        <title>Cloud Migration – Exit Expensive Hyperscalers | Ayanshtech Solutions</title>
        <meta
          name="description"
          content="Migrate your cloud infrastructure from AWS, Azure, Google Cloud, DigitalOcean, OVH, Scaleway, and Linode to cost-effective alternatives without compromising performance or security."
        />
        <meta property="og:title" content="Cloud Migration – Exit Expensive Hyperscalers" />
        <meta property="og:description" content="Save up to 98% on cloud hosting costs. 100% GDPR compliant and EU hosting possible." />
        <meta property="og:type" content="website" />
      </Helmet>
           {/* Cal.com Modal Component */}
      <Reaquestconsultation isOpen={isModalOpen} onClose={closeModal} />
      {/* Main Container */}
        <section className="relative overflow-hidden  text-gray-800 pt-24 md:pt-32 pb-20 min-h-screen flex items-center">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute -top-10 -left-16 w-80 h-80 bg-blue-600/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-purple-600/25 rounded-full blur-3xl"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-transparent to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left Side - Content */}
        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            Everything You Need in One Place
          </h1>
          
          <p className="text-xl text-gray-600 max-w-2xl">
           Manage your services and infrastructure through a centralized customer portal. Monitor activity, track updates, access support, and stay informed with complete visibility and control.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-gray-600">

  {/* Performance Monitoring */}
  <div className="flex items-center gap-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 text-blue-600"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 13.5l4.5-4.5 3 3L21 4.5M21 4.5V10.5M21 4.5H15"
      />
    </svg>
    <span>Performance Monitoring</span>
  </div>

  {/* Activity & Audit Logs */}
  <div className="flex items-center gap-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 text-blue-600"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12h6m-6 4h6M7.5 4.5h9A1.5 1.5 0 0118 6v12a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 18V6a1.5 1.5 0 011.5-1.5z"
      />
    </svg>
    <span>Activity & Audit Logs</span>
  </div>

  {/* Dedicated Support */}
  <div className="flex items-center gap-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 text-blue-600"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 10a6 6 0 10-12 0v4a2 2 0 002 2h2v-4H8v-2a4 4 0 118 0v2h-2v4h2a2 2 0 002-2v-4z"
      />
    </svg>
    <span>Dedicated Technical Support</span>
  </div>

</div>
        </div>

        {/* Right Side - Image Card */}
        <div className="relative">
          {/* Background Glow */}
          <div className="absolute -inset-6 bg-gradient-to-br from-blue-600/30 to-purple-600/20 rounded-3xl blur-3xl"></div>
          
          {/* Image Container */}
          <div className="relative rounded-3xl border border-white/10 shadow-2xl overflow-hidden bg-white/5 backdrop-blur">
            <div className="relative cursor-zoom-in group" onClick={handleImageClick}>
              <img 
                src="../assets/images/migration/wz-portal-dashboard-dc863234c53b57e6e3fcf1ec714027d9.png" 
                alt="WZ-IT Customer Portal Dashboard with Infrastructure Overview" 
                className="w-full h-auto"
              />
              
              {/* Zoom Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 rounded-full p-3">
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    strokeWidth={1.5} 
                    stroke="currentColor" 
                    className="w-6 h-6 text-white"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" 
                    />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Footer */}
            <div className="px-6 py-4 bg-black/50 border-t border-white/10 flex items-center gap-3">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth={1.5} 
                stroke="currentColor" 
                className="w-6 h-6 text-white"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" 
                />
              </svg>
              <div>
                <p className="text-sm font-semibold text-white">Unified Dashboard</p>
                <p className="text-xs text-gray-300">Access key information, updates, and insights from one central location.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <SystemStatusSection/>
    <InfrastructureSection/>
    <TransparencySection/>
    <MaintenanceHistorySection/>
    <FlexibilitySection/>
    <DirectLineSection/>
    <DocumentsSection/>
    <EngineersAtFingertipsSection/>
    <ContactSection openModal={openModal}/>
    </>
  );
};

export default Portal;
